/**
 * After add-to-cart, send shoppers to the cart (or checkout) instead of
 * the notification / app drawer. Used as a conversion test.
 */
(function () {
  var COOKIE = 'evertee_atc_redirect';
  var config = window.everteeCartRedirect || {};
  var mode = config.mode || 'off';

  function getCookie(name) {
    var match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : '';
  }

  function setCookie(name, value, days) {
    var expires = '';
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = '; expires=' + date.toUTCString();
    }
    document.cookie = name + '=' + encodeURIComponent(value) + expires + '; path=/; SameSite=Lax';
  }

  function queryOverride() {
    try {
      var params = new URLSearchParams(window.location.search);
      var value = params.get('atc_redirect');
      if (value === 'cart' || value === 'checkout' || value === 'off') return value;
    } catch (e) {}
    return '';
  }

  function assignSplitVariant() {
    var existing = getCookie(COOKIE);
    if (existing === 'cart' || existing === 'off') return existing;
    var variant = Math.random() < 0.5 ? 'cart' : 'off';
    setCookie(COOKIE, variant, 30);
    return variant;
  }

  function resolveVariant() {
    var override = queryOverride();
    if (override) return override;
    if (mode === 'off' || mode === 'cart' || mode === 'checkout') return mode;
    if (mode === 'split_50') return assignSplitVariant();
    return 'off';
  }

  var variant = resolveVariant();
  window.everteeAtcRedirectVariant = variant;

  try {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'evertee_atc_redirect_assignment',
      atc_redirect_variant: variant,
    });
  } catch (e) {}

  function redirectUrl() {
    if (variant === 'checkout') return config.checkoutUrl || '/checkout';
    return config.cartUrl || (window.routes && window.routes.cart_url) || '/cart';
  }

  function shouldRedirect() {
    if (variant !== 'cart' && variant !== 'checkout') return false;
    var path = window.location.pathname || '';
    if (path === '/cart' || path.indexOf('/cart/') === 0) return false;
    if (path === '/checkout' || path.indexOf('/checkouts') === 0) return false;
    return true;
  }

  window.everteeShouldRedirectAfterAdd = shouldRedirect;
  window.everteeCartRedirectUrl = redirectUrl();

  function goToCart() {
    if (window.everteeBuyNowInFlight) return;
    if (!shouldRedirect()) return;
    window.location.assign(redirectUrl());
  }

  function isCartAddUrl(url) {
    if (!url) return false;
    return /\/cart\/add/i.test(String(url));
  }

  function responseLooksSuccessful(response) {
    if (!response) return false;
    if (typeof response.ok === 'boolean') return response.ok;
    if (typeof response.status === 'number') {
      return response.status >= 200 && response.status < 300;
    }
    return true;
  }

  if (shouldRedirect() && typeof window.fetch === 'function') {
    var originalFetch = window.fetch;
    window.fetch = function () {
      var url = '';
      try {
        var input = arguments[0];
        url = typeof input === 'string' ? input : input && input.url;
      } catch (e) {}

      return originalFetch.apply(this, arguments).then(function (response) {
        if (isCartAddUrl(url) && responseLooksSuccessful(response)) {
          response
            .clone()
            .json()
            .then(function (data) {
              if (data && data.status) return;
              goToCart();
            })
            .catch(function () {
              goToCart();
            });
        }
        return response;
      });
    };
  }

  if (shouldRedirect() && window.XMLHttpRequest) {
    var originalOpen = XMLHttpRequest.prototype.open;
    var originalSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (method, url) {
      this._everteeCartAdd = isCartAddUrl(url);
      return originalOpen.apply(this, arguments);
    };
    XMLHttpRequest.prototype.send = function () {
      if (this._everteeCartAdd) {
        this.addEventListener('load', function () {
          if (this.status >= 200 && this.status < 300) goToCart();
        });
      }
      return originalSend.apply(this, arguments);
    };
  }

})();
